import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import marketingApiController from "../../services/marketing.service";
import HandleError from "../HandleError";
import HandleResponse from "../HandleResponse";
import { contentErrorMessage } from "./contentError";

const marketingErrorMessage = (action, fallback) => contentErrorMessage(action, fallback);

export const BirthdayOfferStoreApi = createAsyncThunk("marketing/create", async (formvalues, thunkAPI) => {
  try {
    const resposedata = await marketingApiController
      .create(formvalues, thunkAPI)
      .then((response) => HandleResponse(thunkAPI, response, "create"))
      .catch((error) => HandleError(thunkAPI, error, "create"));
    return resposedata;
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue({ status: error.response.status, message: message });
  }
});

export const BirthdayOfferUpdateApi = createAsyncThunk("marketing/update", async (formvalues, thunkAPI) => {
  try {
    const resposedata = await marketingApiController
      .update(formvalues, thunkAPI)
      .then((response) => HandleResponse(thunkAPI, response, "update"))
      .catch((error) => HandleError(thunkAPI, error, "update"));
    return resposedata;
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue({ status: error.response.status, message: message });
  }
});

export const BirthdayOfferGridViewApi = createAsyncThunk("marketing/gridview", async (formValues, thunkAPI) => {
  try {
    const resposedata = await marketingApiController
      .view(formValues, thunkAPI)
      .then((response) => HandleResponse(thunkAPI, response, "gridview"))
      .catch((error) => HandleError(thunkAPI, error, "gridview"));
    return resposedata;
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

export const BirthdayOfferDetailApi = createAsyncThunk("marketing/detail", async (formValues, thunkAPI) => {
  try {
    const resposedata = await marketingApiController
      .view(formValues, thunkAPI)
      .then((response) => HandleResponse(thunkAPI, response, "detail"))
      .catch((error) => HandleError(thunkAPI, error, "detail"));
    return resposedata;
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

export const BirthdayOfferDeleteApi = createAsyncThunk("marketing/delete", async (formValues, thunkAPI) => {
  try {
    const resposedata = await marketingApiController
      .deleted(formValues, thunkAPI)
      .then((response) => HandleResponse(thunkAPI, response, "delete"))
      .catch((error) => HandleError(thunkAPI, error, "delete"));
    return resposedata;
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

const initialState = {
  isGridView: [],
  isGridViewError: "",
  isDetailData: "",
  isDetailDataError: "",
  isCreateError: "",
  isUpdateError: "",
  isDeleteError: "",
  isTabView: "",
  isSelectedView: "",
  isOpenAddBirthdayOfferForm: "",
  isOpenEditBirthdayOfferForm: "",
  isOpenClientBirthdayListView: "",
  isApiStatus: {
    BirthdayOfferStoreApi: "",
    BirthdayOfferUpdateApi: "",
    BirthdayOfferGridViewApi: "",
    BirthdayOfferDetailApi: "",
    BirthdayOfferDeleteApi: "",
  },
};

const marketingSlice = createSlice({
  name: "marketing",
  initialState,
  reducers: {
    reset: () => initialState,
    MarketingTabGridView: (state, action) => {
      state.isTabView = action.payload;
    },
    OpenAddBirthdayOfferForm: (state, action) => {
      state.isOpenAddBirthdayOfferForm = action.payload;
    },
    OpenEditBirthdayOfferForm: (state, action) => {
      state.isOpenEditBirthdayOfferForm = action.payload;
    },
    OpenClientBirthdayList: (state, action) => {
      state.isOpenClientBirthdayListView = action.payload;
    },
    MarketingSelectedView: (state, action) => {
      state.isSelectedView = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
    .addCase(BirthdayOfferStoreApi.pending, (state) => {
      state.isCreateError = "";
      state.isApiStatus = { ...state.isApiStatus, BirthdayOfferStoreApi: "loading" };
    })
    .addCase(BirthdayOfferStoreApi.fulfilled, (state, action) => {
      if (state.isGridView && state.isGridView.data) {
        state.isGridView.data = [action.payload, ...state.isGridView.data];
      } else {
        state.isGridView = { data: [action.payload] };
      }
      state.isCreateError = "";
      state.isApiStatus = { ...state.isApiStatus, BirthdayOfferStoreApi: "succeeded" };
    })
    .addCase(BirthdayOfferStoreApi.rejected, (state, action) => {
      state.isCreateError = marketingErrorMessage(action, "Unable to create the marketing offer.");
      state.isApiStatus = { ...state.isApiStatus, BirthdayOfferStoreApi: "failed" };
    })
    .addCase(BirthdayOfferUpdateApi.pending, (state) => {
      state.isUpdateError = "";
      state.isApiStatus = { ...state.isApiStatus, BirthdayOfferUpdateApi: "loading" };
    })
    .addCase(BirthdayOfferUpdateApi.fulfilled, (state, action) => {
      const { id, ...changes } = action.payload;
      const existingData = state.isGridView.data.find((event) => event.id === id);
      if (existingData) {
        Object.keys(changes).map((keyName) => {
          existingData[keyName] = changes[keyName];
        });
      }
      state.isUpdateError = "";
      state.isApiStatus = { ...state.isApiStatus, BirthdayOfferUpdateApi: "succeeded" };
    })
    .addCase(BirthdayOfferUpdateApi.rejected, (state, action) => {
      state.isUpdateError = marketingErrorMessage(action, "Unable to update the marketing offer.");
      state.isApiStatus = { ...state.isApiStatus, BirthdayOfferUpdateApi: "failed" };
    })
    .addCase(BirthdayOfferGridViewApi.pending, (state) => {
      state.isGridViewError = "";
      state.isApiStatus = { ...state.isApiStatus, BirthdayOfferGridViewApi: "loading" };
    })
    .addCase(BirthdayOfferGridViewApi.fulfilled, (state, action) => {
      let old_current_page = state.isGridView.current_page ? state.isGridView.current_page : "";
      let new_current_page = action.payload.current_page ? action.payload.current_page : "";
      let viewdata = state.isGridView && state.isGridView.data;
      let newviewdata = action.payload && action.payload.data;
      state.isGridView = action.payload;
      if (old_current_page && new_current_page && old_current_page < new_current_page && old_current_page != new_current_page) {
        viewdata && newviewdata ? (state.isGridView.data = [...viewdata, ...newviewdata]) : action.payload;
      }
      state.isGridView = action.payload;
      state.isGridViewError = "";
      state.isApiStatus = { ...state.isApiStatus, BirthdayOfferGridViewApi: "succeeded" };
    })
    .addCase(BirthdayOfferGridViewApi.rejected, (state, action) => {
      state.isGridViewError = marketingErrorMessage(action, "Unable to load marketing offers.");
      state.isApiStatus = { ...state.isApiStatus, BirthdayOfferGridViewApi: "failed" };
    })
    .addCase(BirthdayOfferDetailApi.pending, (state) => {
      state.isDetailDataError = "";
      state.isApiStatus = { ...state.isApiStatus, BirthdayOfferDetailApi: "loading" };
    })
    .addCase(BirthdayOfferDetailApi.fulfilled, (state, action) => {
      state.isDetailData = action.payload;
      state.isDetailDataError = "";
      state.isApiStatus = { ...state.isApiStatus, BirthdayOfferDetailApi: "succeeded" };
    })
    .addCase(BirthdayOfferDetailApi.rejected, (state, action) => {
      state.isDetailDataError = marketingErrorMessage(action, "Unable to load the marketing offer.");
      state.isApiStatus = { ...state.isApiStatus, BirthdayOfferDetailApi: "failed" };
    })
    .addCase(BirthdayOfferDeleteApi.pending, (state) => {
      state.isDeleteError = "";
      state.isApiStatus = { ...state.isApiStatus, BirthdayOfferDeleteApi: "loading" };
    })
    .addCase(BirthdayOfferDeleteApi.fulfilled, (state, action) => {
      const { id } = action.payload;
      state.isGridView.data = state.isGridView.data ? state.isGridView.data.filter((item) => item.id != id) : state.isGridView.filter((item) => item.id != id);
      state.isDeleteError = "";
      state.isApiStatus = { ...state.isApiStatus, BirthdayOfferDeleteApi: "succeeded" };
    })
    .addCase(BirthdayOfferDeleteApi.rejected, (state, action) => {
      state.isDeleteError = marketingErrorMessage(action, "Unable to delete the marketing offer.");
      state.isApiStatus = { ...state.isApiStatus, BirthdayOfferDeleteApi: "failed" };
    })
    
  },
});
// Action creators are generated for each case reducer function
export const { reset, MarketingTabGridView, OpenAddBirthdayOfferForm, OpenEditBirthdayOfferForm, OpenClientBirthdayList, MarketingSelectedView } = marketingSlice.actions;
export default marketingSlice.reducer;
